import React from 'react';

import {
  Box,
  FormControl,
  Select,
  MenuItem,
  InputBase,
} from '@material-ui/core';

import active_lang from 'src/langs/jp_en';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';

import { useStyles } from './styles';

import {
  STATUS_CATEGORY_SHOW,
  STATUS_CATEGORY_HIDE,
} from 'src/modals/food_details';
import { useTranslation } from 'react-i18next';

export default function ShowCategorySelect({ formik }) {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <>
      <Box className={classes.TextInputGroup} mt="0.5rem">
        <FormControl fullWidth>
          {/* <Box>{active_lang.SHOW_FOOD}</Box> */}
          {/* <ShowDebug>SHOW_FOOD</ShowDebug> */}
          <Select
            id="category_show"
            {...formik.getFieldProps('category_show')}
            classes={{ root: classes.food_availability, icon: classes.icon }}
            input={<InputBase />}
            IconComponent={KeyboardArrowDownIcon}
            style={{ paddingTop: '0.5rem' }}
          >
            <MenuItem value={STATUS_CATEGORY_SHOW}>
              {t('COMMON_PUBLIC')}
            </MenuItem>
            <MenuItem value={STATUS_CATEGORY_HIDE}>
              {t('COMMON_NOT_PULIC')}
            </MenuItem>
          </Select>
        </FormControl>
      </Box>
    </>
  );
}
